import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'DEPOT_DOC',
  title: 'Wie lädt man ein Dokument hoch oder aktualisiert es?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf die Schaltfläche "Auswählen", rechts neben dem Dokument'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DEPOT_DOC/DE_DEPOT_DOC_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'iehen Sie dann Ihr Dokument in die Mitte des Fensters.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DEPOT_DOC/DE_DEPOT_DOC_2.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie Weiter und bestätigen Sie Ihre Auswahl'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_DEPOT_DOC/DE_DEPOT_DOC_3.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ihr Dokument befindet sich nun im Status " Ausstehende Überprüfung ". Jedes Dokument wird von unseren Teams authentifiziert und validiert.'
  }]
};
